<template>
		<div class="content home-page" style = 'padding-top: 20px;background:url(../../static/images/login-bg.jpg) no-repeat 0 0;background-size: cover;'>
      <div class="" @click="back" style="width: 100px;height:100px;text-align: center;display: flex;align-items: center;justify-content: center;margin-top: 20px">
        <img width="50" src="../../static/images/back.png" />
      </div>
			<div class="information2">
				<div class="faq-content" v-if="list!=''">
					<div class="">
						<p class="fs50 ac"><span>{{$t('FAQ')}}</span></p>
						<p class="mt30" v-html="list"></p>
					</div>
				</div>
			</div>
		</div>
</template>
<script>
import Header from '../components/Header'
export default {
    components:{
		Header
    },
    data() {
        return {
			list:[]

		}
    },
	created(){
		this.getHome();
	},
    methods: {
		back(){
			this.$router.go(-1);
		},
		getHome(){
			let that =this;
			that.$parent.loadModal(true);
      let data = {
        type:'1'
      }
			that.$api.post('/api/index/help',data,r =>{
				that.$parent.returnCode(r,function(){
          if(localStorage.getItem('lang')=='en'){
            that.list = r.data.content
          }else{
            that.list = r.data.mm_content
          }
					that.$parent.loadModal(false);
				});

			})

		}
	}
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/page/faq2.vue